import { Add, Edit, Save } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Divider,
  FormControl,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { makeStyles } from "tss-react/mui";
import { updateCost } from "../../../../actions/costs";
import { getNotification } from "../../../../actions/notification";
import InnerDetails from "../InnerDetails/InnerDetails";
import NotificationAttachments from "../../NotificationAttachments";
import { canUserPerformAction } from "../../../../shared-functions/userrights";
import { Link } from "react-router-dom";
import moment from "moment";
import { Theme247 } from "../../../../styles/Theme247";
import { ApplyStyle as _s } from "../../../../utils/ApplyStyle";
import { ReactComponent as RoundedEditSvg } from "../../../../assets/roundedEdit.svg";
import IconText from "../../../../components/IconText";
import clsx from "clsx";
// import { getUnits } from "../../../../shared-functions/units";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getUnits } from "../../../../actions/counters";
import { GermanNumericFormat } from "../../../../components/GermanNumberInput";
import { ReactComponent as EventSVG } from "../../../../assets/Event.svg";
import {
  getNotificationOwner,
  isMachineOwner,
} from "../../../../utils/notificationOwner";

const DEFAULT_PARK_CURRENCY = {
  unitId: "EUR",
  namespace: "https://www.iso.org/iso-4217-currency-codes",
};

const useStyles = makeStyles()({
  table: {
    borderCollapse: "separate",
    "& tbody tr:last-child td": {
      borderBottom: "none",
    },
  },
});

export default connect(
  ({ notification, i18n, profile, language, units }) => ({
    notification,
    i18n,
    profile,
    language,
    units,
  }),
  { updateCost, getNotification, getUnits }
)((props) => {
  const { units } = props;

  const i18n = props.i18n;
  const notiType = props?.notification?.notification?.type;
  const notification = props?.notification;
  // Pools/areas carry no currency; their costs default to EUR like the GMT form.
  const notificationOwner = getNotificationOwner(notification?.notification);
  const notificationCurrency = isMachineOwner(notificationOwner)
    ? notificationOwner.owner?.equipmentcurrency
    : notificationOwner.owner
    ? DEFAULT_PARK_CURRENCY
    : undefined;

  const [editingColumn, setEditingColumn] = useState(null);
  const [planCost, setPlanCost] = useState(10);
  const [ist, setIst] = useState(20);

  const [costs, setCosts] = useState();
  const [plancosts, setPlanCosts] = useState();

  const store = useStore().getState();
  const handleEdit = (columnIndex) => {
    setEditingColumn(columnIndex);
  };

  const getDateFromTimestamp = (unixTimeStamp) => {
    let date = new Date(unixTimeStamp);
    return (
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1 <= 9
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) +
      "-" +
      (date.getDate() <= 9 ? "0" + date.getDate() : date.getDate())
    );
  };
  const getTimeFromTimestamp = (unixTimeStamp) => {
    let date = new Date(unixTimeStamp);
    return (
      date.getHours() +
      ":" +
      (date.getMinutes() <= 9 ? "0" + date.getMinutes() : date.getMinutes())
    );
  };
  var ids = [];

  if (notification?.notification?.hasattachment !== undefined) {
    notification.notification.hasattachment.map((i, k) => {
      var id = i?.attachment?.file?.fileid;
      ids.push(id);
    });
  }

  var executed_date = "";
  var executed_time = "";
  if (notification?.notification?.hasreport?.[0]?.report != undefined) {
    executed_date = getDateFromTimestamp(
      moment(notification.notification.hasreport[0].report.executed)
    );
    executed_time = getTimeFromTimestamp(
      moment(notification.notification.hasreport[0].report.executed)
    );
  }

  const date_today = getDateFromTimestamp(moment(Date.now()));
  const time_today = getTimeFromTimestamp(moment(Date.now()));

  const [textFields, setTextFields] = useState([]);
  const handleSave = () => {
    setEditingColumn(null);
    setCosts([]);
    textFields.length > 0 &&
      textFields.map((item) => {
        props.updateCost({
          lang: store.language,
          nodeid: item.nodeid,
          name: item.name,
          value: parseFloat(item.value),
          costTypeNodeId: item.costTypeNodeId,
          hasCostSourceNodeId: item.hasCostSourceNodeId,
          specifier: item.specifier,
          unit:
            notificationCurrency,
        });
      });

    props.getNotification(
      { nodeid: props.notification.notification?.nodeid },
      "GETSINGLENOTIFICATION"
    );
    setTextFields([]);
  };

  const columnsPlanActual = [
    { title: "Aufwand", content: "" },
    { title: "Geplanter Aufwand", content: planCost },
    { title: "Ist-Aufwand", content: ist },
  ];
  const columnsPlan = [
    { title: "Aufwand", content: "" },
    { title: "Geplanter Aufwand", content: ist },
  ];

  const columnsActual = [
    { title: "Aufwand", content: "" },
    { title: "Ist-Aufwand", content: ist },
  ];

  const handleTextFieldChange = (
    hasCostSourceNodeId,
    specifier,
    id,
    nodeid,
    costTypeNodeId,
    name,
    value
  ) => {
    setTextFields((textFields) => {
      const index = textFields.findIndex((tf) => tf.id === id);
      if (index === -1) {
        // text field doesn't exist yet, so create a new object
        return [
          ...textFields,
          {
            id,
            name,
            value,
            nodeid,
            costTypeNodeId,
            specifier,
            hasCostSourceNodeId,
          },
        ];
      } else {
        // text field already exists, so update its value
        const updatedTextField = {
          ...textFields[index],
          name,
          value,
          nodeid,
          costTypeNodeId,
          specifier,
          hasCostSourceNodeId,
        };
        return [
          ...textFields.slice(0, index),
          updatedTextField,
          ...textFields.slice(index + 1),
        ];
      }
    });
  };

  const stundenCostNodeIds = [
    "247fn://247uptime.io/8e0ce52b-c1ab-4104-834d-758a167e179f",
    "247fn://247uptime.io/cc42db6e-243f-4606-a38a-780fe1b35a1e",
  ];
  const euroCostNodeIds = [
    "247fn://247uptime.io/95f0ccfc-7943-4f87-b969-d0796f53dd0e",
    "247fn://247uptime.io/f0e5f689-baad-4494-970d-cffc842ae794",
    "247fn://247uptime.io/f7fcdb17-0a9c-40e2-857d-712baa2cd745",
  ];

  const getPlanCostData = (ct) => {
    /* console.log(ct, "CT"); */
    if (
      props?.notification?.notification?.hasmaintenancetask &&
      props?.notification?.notification?.hasmaintenancetask[0]?.maintenancetask
        ?.hascost?.length
    ) {
      const tempArray = [];
      const filteredCost = plancosts.filter(
        (ctc) => ctc.cost.name === ct.cost?.name
      );

      if (filteredCost && filteredCost.length) {
        tempArray.push(filteredCost[0].cost.nodeid);
        tempArray.push(filteredCost[0].cost.value);
        tempArray.push(filteredCost[0].cost.hascosttype?.[0]?.costtype?.nodeid);
        tempArray.push(
          props.notification?.notification?.hasmaintenancetask[0]
            ?.maintenancetask?.nodeid
        );
        tempArray.push(
          euroCostNodeIds.includes(
            filteredCost[0].cost.hascosttype?.[0]?.costtype?.nodeid
          )
            ? notificationCurrency?.unitId || ""
            : "Stunden"
        );
      }
      return tempArray;
    } else if (props?.notification?.notification?.hascost?.length) {
      const tempArray = [];
      const filteredCost = plancosts.filter(
        (ctc) => ctc.cost.name === ct.cost?.name
      );

      if (filteredCost && filteredCost.length) {
        tempArray.push(filteredCost[0].cost.nodeid);
        tempArray.push(filteredCost[0].cost.value);
        tempArray.push(filteredCost[0].cost.hascosttype?.[0]?.costtype?.nodeid);
        tempArray.push(props.notification?.notification?.nodeid);
        tempArray.push(
          euroCostNodeIds.includes(
            filteredCost[0].cost.hascosttype?.[0]?.costtype?.nodeid
          )
            ? notificationCurrency?.unitId || ""
            : "Stunden"
        );
      }
      return tempArray;
    }
  };

  useEffect(() => {
    const originalArray = props.notification?.notification?.hascost;
    if (originalArray?.length) {
      const sortedArray = originalArray.sort((a, b) =>
        a.cost.name?.localeCompare(b.cost.name)
      );
      setCosts(sortedArray);
    }

    if (
      props?.notification?.notification?.hasmaintenancetask &&
      props?.notification?.notification?.hasmaintenancetask[0]?.maintenancetask
        ?.hascost?.length
    ) {
      const sortedArray = props?.notification?.notification?.hasmaintenancetask[0]?.maintenancetask?.hascost.sort(
        (a, b) => a.cost.name?.localeCompare(b.cost.name)
      );
      setPlanCosts(sortedArray);
    } else if (props?.notification?.notification?.hascost?.length) {
      const sortedArray = props?.notification?.notification?.hascost.sort(
        (a, b) => a.cost.name?.localeCompare(b.cost.name)
      );
      setPlanCosts(sortedArray);
    }
  }, [props.notification?.notification]);

  const { classes } = useStyles();

  const authorName = notification?.notification?.hasreport
    ? notification?.notification?.hasreport[0]?.report?.authorsignature
    : "";

  let hasAuthorSigImage = props?.notification?.notification?.hasreport
    ? Object.keys(
        props?.notification?.notification?.hasreport[0]?.report
          ?.authorsignatureimage || {}
      ).length
    : false;

  let signedBy = notification?.notification?.hasreport
    ? notification?.notification?.hasreport[0]?.report?.hasauthor &&
      notification?.notification?.hasreport[0]?.report?.hasauthor[0]?.user
        ?.givenname +
        " " +
        notification?.notification?.hasreport[0]?.report?.hasauthor[0]?.user
          ?.surname
    : "";

  const reportCreated = notification?.notification?.hasreport
    ? notification?.notification?.hasreport[0]?.report?.created
    : "";

  useEffect(() => {
    if (units.length === 0) {
      props.getUnits("UNITS");
    }
  }, []);

  return (
    <>
      {/* {notiType !== 6 && <InnerDetails notification={props.notification} />} */}

      {notiType !== 6 && !props.fromOverview ? (
        <div style={{ padding: "28px 24px 0px 24px" }}>
          <div
            className={_s(Theme247.sectionHeader)}
            style={{ marginBottom: "10px" }}
          >
            <div
              style={{ display: "flex", width: "100%", alignItems: "center" }}
            >
              <div>
                <Typography variant="h1">Aufwandserfassung</Typography>
              </div>
              <div style={{ marginLeft: "20px" }}>
                {editingColumn === 1 ? (
                  ""
                ) : (
                  <IconButton onClick={() => handleEdit(1)}>
                    <RoundedEditSvg />
                  </IconButton>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      {notiType === 6 && !props.fromOverview && (
        <Grid
          container
          alignItems="center"
          className={_s(Theme247.sectionContentContainer)}
        >
          <Typography variant="h1" component="h2">
            {i18n.maintenance_report}
          </Typography>

          {notification.notification?.hasreport == undefined ? (
            <>
              <Grid
                xs={12}
                className={classes.notificationDetailsContainer}
                style={{ paddingLeft: 0, marginTop: 25 }}
              >
                <Typography variant="body2">
                  {i18n.maintenance_report_empty}
                </Typography>
              </Grid>
              {/* Start the report right here too, as from the Beschreibung
                  tab (Mathias, 31.10.2026). */}
              {canUserPerformAction(
                props.profile?.features?.["notification.report"],
                "create"
              ) ? (
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<EventSVG />}
                    sx={{ letterSpacing: "1.25px" }}
                    data-testid="btn_report_carry_now"
                    onClick={() => props?.setProtokolEditView(true)}
                  >
                    {i18n.carry_now}
                  </Button>
                </Grid>
              ) : null}
            </>
          ) : (
            <>
              <Grid
                xs={12}
                className={classes.notificationDetailsContainer}
                style={{ paddingLeft: 0, marginTop: -10 }}
              >
                <IconText
                  icon={
                    <svg
                      width="16"
                      height="17"
                      viewBox="0 0 16 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_3687_10215"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="16"
                        height="17"
                      >
                        <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_3687_10215)">
                        <path
                          d="M9.75016 11.1834C9.87239 11.3056 10.0224 11.3667 10.2002 11.3667C10.3779 11.3667 10.5335 11.3 10.6668 11.1667C10.7891 11.0445 10.8502 10.8889 10.8502 10.7C10.8502 10.5112 10.7891 10.3556 10.6668 10.2334L8.66683 8.23337V5.81671C8.66683 5.62782 8.60305 5.47226 8.4755 5.35004C8.3475 5.22782 8.18905 5.16671 8.00016 5.16671C7.81127 5.16671 7.65305 5.23049 7.5255 5.35804C7.3975 5.48604 7.3335 5.64449 7.3335 5.83337V8.48337C7.3335 8.57226 7.35016 8.65826 7.3835 8.74137C7.41683 8.82493 7.46683 8.90004 7.5335 8.96671L9.75016 11.1834ZM8.00016 15.1667C7.07794 15.1667 6.21127 14.9916 5.40016 14.6414C4.58905 14.2916 3.8835 13.8167 3.2835 13.2167C2.6835 12.6167 2.20861 11.9112 1.85883 11.1C1.50861 10.2889 1.3335 9.42226 1.3335 8.50004C1.3335 7.57782 1.50861 6.71115 1.85883 5.90004C2.20861 5.08893 2.6835 4.38337 3.2835 3.78337C3.8835 3.18337 4.58905 2.70826 5.40016 2.35804C6.21127 2.00826 7.07794 1.83337 8.00016 1.83337C8.92239 1.83337 9.78905 2.00826 10.6002 2.35804C11.4113 2.70826 12.1168 3.18337 12.7168 3.78337C13.3168 4.38337 13.7917 5.08893 14.1415 5.90004C14.4917 6.71115 14.6668 7.57782 14.6668 8.50004C14.6668 9.42226 14.4917 10.2889 14.1415 11.1C13.7917 11.9112 13.3168 12.6167 12.7168 13.2167C12.1168 13.8167 11.4113 14.2916 10.6002 14.6414C9.78905 14.9916 8.92239 15.1667 8.00016 15.1667ZM8.00016 13.8334C9.47794 13.8334 10.7364 13.314 11.7755 12.2754C12.8142 11.2363 13.3335 9.97782 13.3335 8.50004C13.3335 7.02226 12.8142 5.76382 11.7755 4.72471C10.7364 3.68604 9.47794 3.16671 8.00016 3.16671C6.52239 3.16671 5.26416 3.68604 4.2255 4.72471C3.18638 5.76382 2.66683 7.02226 2.66683 8.50004C2.66683 9.97782 3.18638 11.2363 4.2255 12.2754C5.26416 13.314 6.52239 13.8334 8.00016 13.8334Z"
                          fill="black"
                          fill-opacity="0.5"
                        />
                      </g>
                    </svg>
                  }
                  text={
                    i18n.protocol_title_pretext +
                    " : " +
                    moment(
                      notification.notification?.hasreport[0]?.report?.executed
                    ).format("DD.MM.YYYY") +
                    ", " +
                    moment(
                      notification.notification?.hasreport[0]?.report?.executed
                    ).format("HH:mm") +
                    " Uhr "
                  }
                />

                <IconText
                  style={{ marginLeft: "36px" }}
                  icon={
                    <svg
                      width="16"
                      height="17"
                      viewBox="0 0 16 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_3687_13131"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="16"
                        height="17"
                      >
                        <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_3687_13131)">
                        <path
                          d="M7.99984 8.49996C7.2665 8.49996 6.63873 8.23885 6.1165 7.71663C5.59428 7.1944 5.33317 6.56663 5.33317 5.83329C5.33317 5.09996 5.59428 4.47218 6.1165 3.94996C6.63873 3.42774 7.2665 3.16663 7.99984 3.16663C8.73317 3.16663 9.36095 3.42774 9.88317 3.94996C10.4054 4.47218 10.6665 5.09996 10.6665 5.83329C10.6665 6.56663 10.4054 7.1944 9.88317 7.71663C9.36095 8.23885 8.73317 8.49996 7.99984 8.49996ZM11.9998 13.8333H3.99984C3.63317 13.8333 3.31928 13.7027 3.05817 13.4416C2.79706 13.1805 2.6665 12.8666 2.6665 12.5V11.9666C2.6665 11.5888 2.76373 11.2416 2.95817 10.925C3.15262 10.6083 3.41095 10.3666 3.73317 10.2C4.42206 9.85551 5.12206 9.59718 5.83317 9.42496C6.54428 9.25274 7.2665 9.16663 7.99984 9.16663C8.73317 9.16663 9.45539 9.25274 10.1665 9.42496C10.8776 9.59718 11.5776 9.85551 12.2665 10.2C12.5887 10.3666 12.8471 10.6083 13.0415 10.925C13.2359 11.2416 13.3332 11.5888 13.3332 11.9666V12.5C13.3332 12.8666 13.2026 13.1805 12.9415 13.4416C12.6804 13.7027 12.3665 13.8333 11.9998 13.8333ZM3.99984 12.5H11.9998V11.9666C11.9998 11.8444 11.9693 11.7333 11.9082 11.6333C11.8471 11.5333 11.7665 11.4555 11.6665 11.4C11.0665 11.1 10.4609 10.875 9.84984 10.725C9.23873 10.575 8.62206 10.5 7.99984 10.5C7.37761 10.5 6.76095 10.575 6.14984 10.725C5.53873 10.875 4.93317 11.1 4.33317 11.4C4.23317 11.4555 4.15261 11.5333 4.0915 11.6333C4.03039 11.7333 3.99984 11.8444 3.99984 11.9666V12.5ZM7.99984 7.16663C8.3665 7.16663 8.68039 7.03607 8.9415 6.77496C9.20261 6.51385 9.33317 6.19996 9.33317 5.83329C9.33317 5.46663 9.20261 5.15274 8.9415 4.89163C8.68039 4.63051 8.3665 4.49996 7.99984 4.49996C7.63317 4.49996 7.31928 4.63051 7.05817 4.89163C6.79706 5.15274 6.6665 5.46663 6.6665 5.83329C6.6665 6.19996 6.79706 6.51385 7.05817 6.77496C7.31928 7.03607 7.63317 7.16663 7.99984 7.16663Z"
                          fill="black"
                          fill-opacity="0.5"
                        />
                      </g>
                    </svg>
                  }
                  text={"Durchgeführt von "}
                  right={
                    <span style={{ color: "rgba(56, 116, 141, 1)" }}>
                      {notification?.notification?.hasreport[0]?.report
                        ?.hasauthor &&
                        notification?.notification?.hasreport[0]?.report
                          ?.hasauthor[0]?.user?.givenname +
                          " " +
                          notification.notification?.hasreport[0]?.report
                            ?.hasauthor &&
                        notification?.notification?.hasreport[0]?.report
                          ?.hasauthor[0]?.user?.surname}
                    </span>
                  }
                />
              </Grid>

              <Grid
                xs={12}
                className={classes.notificationDetailsContainer}
                style={{ paddingLeft: 0, marginTop: 35 }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    maxWidth: "100%",
                    wordWrap: "break-word",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {notification.notification?.hasreport[0]?.report?.comment}
                </Typography>
              </Grid>
              <Grid
                xs={12}
                className={classes.notificationDetailsContainer}
                style={{ paddingLeft: 0, marginTop: 0 }}
              >
                <NotificationAttachments
                  from="notification"
                  attachmentsOf={"report"}
                  rootNodeId={notification.notification?.nodeid}
                  edit={false}
                  workflowAttachments={
                    notification.notification?.hasreport[0]?.report?.hasattachment
                  }
                />
              </Grid>
            </>
          )}
        </Grid>
      )}

      {(notiType === 6 && notification.notification?.hasreport !== undefined) ||
      notiType !== 6 ? (
        <>
          {notiType === 6 ? (
            <Typography
              variant="h2"
              component="h3"
              className={classes.headlineSpacer}
              sx={{ margin: "24px" }}
            >
              {props.fromOverview ? "Planungskosten" : "Aufwandserfassung"}
            </Typography>
          ) : (
            ""
          )}

          <TableContainer sx={{ overflow: "hidden" }}>
            <Table
              className={clsx(classes.table, "costTable")}
              sx={{
                width: "876px",
                overflow: "none",
                margin: "10px 24px",
              }}
            >
              <TableHead>
                <TableRow sx={{ margin: "0px 0px 10px 0px", display: "flex" }}>
                  {props.notification &&
                  props.notification.notification?.type === 6
                    ? props.fromOverview
                      ? columnsPlan.slice(0, 2).map((column, index) => (
                          <React.Fragment key={index}>
                            <TableCell
                              style={{
                                margin: "0px",
                                width: index === 0 ? "45%" : "55%",
                                padding: "24px 0px",
                                height: "fitContent",
                              }}
                              className="headerCell"
                            >
                              {column.title}
                            </TableCell>
                          </React.Fragment>
                        ))
                      : columnsPlanActual.slice(0, 3).map((column, index) => (
                          <React.Fragment key={index}>
                            <TableCell
                              style={{
                                margin: "0px",
                                width: "33%",
                                padding: "24px 0px",
                                height: "fitContent",
                              }}
                              className="headerCell"
                            >
                              {column.title}
                            </TableCell>
                          </React.Fragment>
                        ))
                    : columnsActual.slice(0, 2).map((column, index) => (
                        <React.Fragment key={index}>
                          <TableCell
                            className="headerCell"
                            style={{
                              padding: "0px",
                              border: "none",
                              width: "50%",
                              // marginLeft: index !== 0 ? "30px" : "",
                            }}
                          >
                            {column.title}
                          </TableCell>
                        </React.Fragment>
                      ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {props.notification &&
                props.notification?.notification?.hasmaintenancetask !=
                  undefined &&
                props.notification.notification.type === 6
                  ? props.fromOverview
                    ? plancosts &&
                      plancosts.map((ct, k) => {
                        return ct?.cost?.hascosttype?.[0]?.costtype?.nodeid !==
                          "247fn://247uptime.io/177c391e-a456-4263-8315-9eb230c4101c" ? (
                          <TableRow className="contentRow">
                            {columnsPlan.slice(0, 2).map((column, index) => {
                              return (
                                <TableCell
                                  key={index}
                                  style={{
                                    marginLeft: index === 2 ? "" : "",
                                    width: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    position: index === 2 ? "" : "",
                                    padding: "0px",
                                  }}
                                >
                                  {index === 1 || index === 2 ? (
                                    <>
                                      {new Intl.NumberFormat("de-DE", {
                                        currency: "EUR",
                                      }).format(getPlanCostData(ct)[1])}
                                      <div
                                        className="unit"
                                        style={{ marginLeft: "15px" }}
                                      >
                                        
                                        {getPlanCostData(ct)
                                          ? getPlanCostData(ct)[4]
                                          : notificationCurrency?.unitId || ""}
                                        
                                      </div>
                                    </>
                                  ) : (
                                    <div
                                      className="cost"
                                      style={{
                                        color: "#000000DE",
                                        fontSize: 16,
                                        fontFamily: "Roboto, sans-serif",
                                        fontWeight: 400,
                                        lineHeight: 1.2,
                                      }}
                                    >
                                      {ct?.cost?.name}
                                    </div>
                                  )}
                                </TableCell>
                              );
                            })}
                            <TableCell sx={{ width: "10%" }}></TableCell>
                          </TableRow>
                        ) : (
                          ""
                        );
                      })
                    : costs &&
                      costs.map((ct, k) =>
                        ct?.cost?.hascosttype?.[0]?.costtype?.nodeid !==
                        "247fn://247uptime.io/177c391e-a456-4263-8315-9eb230c4101c" ? (
                          <TableRow key={k} className="contentRow">
                            {columnsPlanActual
                              .slice(0, 3)
                              .map((column, index) => (
                                <TableCell
                                  key={index}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "50%",
                                    padding: "5px 0px",
                                  }}
                                >
                                  {index !== 0 ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "baseline",
                                      }}
                                    >
                                      <div>
                                        {
                                            new Intl.NumberFormat("de-DE", {  currency: "EUR", }).format(
                                              index === 1
                                          ? getPlanCostData(ct) &&
                                            getPlanCostData(ct)[1]
                                          : ct?.cost?.value,
                                            )
                                        }
                                      </div>

                                      <div
                                        className="unit"
                                        style={{ marginLeft: "10px" }}
                                      >
                                        
                                        {getPlanCostData(ct)
                                          ? getPlanCostData(ct)[4]
                                          : notificationCurrency?.unitId || ""}
                                        
                                      </div>
                                    </div>
                                  ) : (
                                    <div
                                      className="cost"
                                      style={{
                                        color: "#000000DE",
                                        fontSize: 16,
                                        fontFamily: "Roboto, sans-serif",
                                        fontWeight: 400,
                                        lineHeight: 1.2,
                                      }}
                                    >
                                      {ct?.cost?.name}
                                    </div>
                                  )}
                                </TableCell>
                              ))}
                          </TableRow>
                        ) : (
                          ""
                        )
                      )
                  : costs &&
                    costs.map((ct, k) =>
                      ct?.cost?.hascosttype?.[0]?.costtype?.nodeid !==
                      "247fn://247uptime.io/177c391e-a456-4263-8315-9eb230c4101c" ? (
                        <TableRow key={k} className="contentRow">
                          {columnsActual.slice(0, 2).map((column, index) => (
                            <TableCell
                              key={index}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                width: "50%",
                                padding: "5px 0px",
                              }}
                            >
                              {index === 1 ? (
                                editingColumn === index ? (
                                  <FormControl
                                    variant="standard"
                                    sx={{ m: 0, width: "25ch" }}
                                  >
                                    <Input
                                      defaultValue={ct?.cost?.value}
                                      value={ct?.cost?.value}
                                      inputComponent={GermanNumericFormat}
                                      onChange={(event) =>
                                        handleTextFieldChange(
                                          props.notification?.notification
                                            ?.nodeid,
                                          "actualcost",
                                          k,
                                          ct?.cost?.nodeid,
                                          ct?.cost?.hascosttype?.[0]?.costtype
                                            ?.nodeid,
                                          ct?.cost?.name,
                                          event.target.value
                                        )
                                      }
                                      id="standard-adornment-weight"
                                      endAdornment={
                                        <InputAdornment position="end">
                                          <div className="unit">
                                            {getPlanCostData(ct)
                                              ? getPlanCostData(ct)[4]
                                              : notificationCurrency?.unitId ||
                                                ""}
                                          </div>
                                        </InputAdornment>
                                      }
                                    />
                                  </FormControl>
                                ) : (
                                  <>
                                    {/* <TextField
                                    className="costInput"
                                    variant="standard"
                                    size="small"
                                    fullWidth
                                    InputProps={{
                                      disableUnderline: true,
                                      readOnly: true,
                                    }}
                                    defaultValue={ct?.cost?.value}
                                    style={{
                                      border: "none",
                                      borderRadius: "0px",
                                      width: "6%",
                                      color: "00000080",
                                      fontWeight: "400",
                                      fontFamily: "Roboto",
                                    }}
                                  /> */}

                                  {
                                    new Intl.NumberFormat("de-DE", {
                                      currency: "EUR",
                                    }).format(ct?.cost?.value)
                                  }
                                    <div
                                      className="unit"
                                      style={{ marginLeft: "10px" }}
                                    >
                                      {getPlanCostData(ct)
                                        ? getPlanCostData(ct)[4]
                                        : notificationCurrency?.unitId || ""}
                                    </div>
                                  </>
                                )
                              ) : (
                                <div
                                  className="cost"
                                  style={{
                                    color: "#000000DE",
                                    fontSize: 16,
                                    fontFamily: "Roboto, sans-serif",
                                    fontWeight: 400,
                                    lineHeight: 1.2,
                                  }}
                                >
                                  {ct?.cost?.name}
                                </div>
                              )}
                            </TableCell>
                          ))}
                        </TableRow>
                      ) : (
                        ""
                      )
                    )}
              </TableBody>
            </Table>
          </TableContainer>

          {editingColumn !== null ? (
            <Button
              variant="contained"
              onClick={handleSave}
              sx={{ margin: "0px 0px 24px 24px" }}
            >
              {i18n.save}
            </Button>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}

      <>
        {props.fromOverview ? (
          ""
        ) : notification.notification?.hasreport &&
          notification.notification.type === 6 ? (
          <>
            <div
              style={{
                margin: 20,
              }}
            >
              <Accordion className="sigAccordian">
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Typography variant="h1">{"Bestätigung"}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="fullNameSigReadOnlyWrapper">
                    {hasAuthorSigImage ? (
                      <div className="fullNameSigImg" style={{ width: "40%" }}>
                        <img
                          src={
                            props.notification?.notification?.hasreport?.[0]
                              ?.report?.authorsignatureimage?.url
                          }
                        />
                        <div>Unterschrift</div>
                      </div>
                    ) : (
                      <div className="fullNameSigReadOnly">{authorName}</div>
                    )}

                    <div className="text">
                      Diese Report wurde erstellt und digital signiert von{" "}
                      <b>{signedBy}</b> am{" "}
                      {moment(reportCreated).format("DD.MM.YYYY")}{" "}
                      {moment(reportCreated).format("HH:mm")} Uhr.
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
            <Divider orientation="horizontal" sx={{ margin: "10px 0px" }} />
            <div
              style={{
                margin: 20,
              }}
            >
              <div className={classes.sectionButtonFooter}>
                {canUserPerformAction(
                  props.profile?.features?.["notification.report"],
                  "update"
                ) && (
                  <Button
                    variant="outlined"
                    startIcon={
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_3687_11900"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="18"
                          height="18"
                        >
                          <rect width="18" height="18" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_3687_11900)">
                          <path
                            d="M3.75 14.25H4.8L11.2687 7.78125L10.2188 6.73125L3.75 13.2V14.25ZM14.475 6.69375L11.2875 3.54375L12.3375 2.49375C12.625 2.20625 12.9783 2.0625 13.3973 2.0625C13.8158 2.0625 14.1687 2.20625 14.4562 2.49375L15.5062 3.54375C15.7937 3.83125 15.9437 4.17825 15.9562 4.58475C15.9688 4.99075 15.8313 5.3375 15.5438 5.625L14.475 6.69375ZM3 15.75C2.7875 15.75 2.6095 15.678 2.466 15.534C2.322 15.3905 2.25 15.2125 2.25 15V12.8812C2.25 12.7812 2.26875 12.6845 2.30625 12.591C2.34375 12.497 2.4 12.4125 2.475 12.3375L10.2 4.6125L13.3875 7.8L5.6625 15.525C5.5875 15.6 5.50325 15.6562 5.40975 15.6937C5.31575 15.7312 5.21875 15.75 5.11875 15.75H3Z"
                            fill="#0E3F51"
                          />
                        </g>
                      </svg>
                    }
                    color="primary"
                    onClick={() => {
                      props?.setProtokolEditView(true);
                    }}
                  >
                    {i18n.protocol_update}
                  </Button>
                )}
              </div>
            </div>
          </>
        ) : notiType === 6 ? (
          <>
            {" "}
            <Divider orientation="horizontal" />
            {/* <Grid
              xs={12}
              className={classes.notificationDetailsContainer}
              style={{ paddingLeft: 0, margin: "20px 25px" }}
            >
              {canUserPerformAction(
                props.profile?.features?.["notification.report"],
                "create"
              ) && (
                <div className={classes.itemcardButtonFooter}>
                  <Link
                    className="btn-submit"
                    to="/create-report"
                    state={{
                      date: date_today,
                      time: time_today,
                      notificationnodeid: notification.notification?.nodeid,
                      pageType: "add",
                    }}
                  >
                    <Button startIcon={<Add />} variant="outlined">
                      {i18n.maintenance_report_add_btn}
                    </Button>
                  </Link>
                </div>
              )}
            </Grid> */}
          </>
        ) : (
          ""
        )}
      </>
    </>
  );
});
